import React from 'react'; // metrics

interface SearchSummaryMetricsProps {
  summary: {
    totalRecommended?: number;
    highPriority?: number;
    mediumPriority?: number;
    manualVerification?: number;
  };
}

export const SearchSummaryMetrics: React.FC<SearchSummaryMetricsProps> = ({ summary }) => {
  return (
    <div className="grid grid-cols-3 gap-2 md:gap-5">
      <div className="bg-white dark:bg-slate-900 p-3 lg:p-5 rounded-2xl border border-blue-100 dark:border-slate-800 text-center shadow-[0_2px_10px_-3px_rgba(59,130,246,0.1)]">
        <p className="text-xl md:text-3xl font-extrabold text-blue-600 dark:text-blue-400">{summary?.totalRecommended || 0}</p>
        <p className="text-[9px] md:text-[11px] font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider mt-1.5 truncate">Total Jobs</p>
      </div>
      <div className="bg-white dark:bg-emerald-500/10 p-3 lg:p-5 rounded-2xl border border-emerald-100 dark:border-emerald-500/20 text-center shadow-[0_2px_10px_-3px_rgba(16,185,129,0.1)]">
        <p className="text-xl md:text-3xl font-extrabold text-emerald-500 dark:text-emerald-400">{summary?.highPriority || 0}</p>
        <p className="text-[9px] md:text-[11px] font-semibold text-emerald-600 dark:text-emerald-500 uppercase tracking-wider mt-1.5 truncate">Strong Matches</p>
      </div>
      <div className="bg-white dark:bg-amber-500/10 p-3 lg:p-5 rounded-2xl border border-amber-100 dark:border-amber-500/20 text-center shadow-[0_2px_10px_-3px_rgba(245,158,11,0.1)]">
        <p className="text-xl md:text-3xl font-extrabold text-amber-500 dark:text-amber-400">{summary?.mediumPriority || 0}</p>
        <p className="text-[9px] md:text-[11px] font-semibold text-amber-600 dark:text-amber-500 uppercase tracking-wider mt-1.5 truncate">Potential Fits</p>
      </div>
    </div>
  );
};
